import type { BorderSize, ThemeOptionVariant } from '@dhl-ui/theme'

const borderPx = (size: number): number => (size === 3 ? 4 : size)

const variantScaleMap: Record<ThemeOptionVariant, number> = {
  desktop: 0.9,
  mobile: 1,
  tablet: 1,
  md: 1.4,
  lg: 1.5,
  xl: 2.5,
}

const variantScale = (variant: ThemeOptionVariant): number => Math.max(1, variantScaleMap[variant])

const scaledBorderPx = (basePx: number, variant: ThemeOptionVariant): number => {
  const scale = variantScale(variant)

  if (scale === 1) {
    return basePx
  }

  // Keep very thin borders legible on medium scaling modes.
  if (scale < 2 && basePx <= 2) {
    return basePx * 2
  }

  return Math.round(basePx * scale)
}

export const createBorderSize =
  (variant: ThemeOptionVariant = 'desktop') =>
  (size: BorderSize = 1): string => {
    const sign = size < 0 ? -1 : 1
    const px = scaledBorderPx(borderPx(Math.abs(size)), variant)

    return `${sign * px}px`
  }

export const borderSize = createBorderSize('desktop')
